import React from 'react';
import Waves from '../components/waves';
import Navigation from '../components/navigation';
import Cta from '../components/cta';
import Footer from '../components/footer';

import dario2 from '../images/dario2.jpeg'
import ryan from '../images/ryan.jpeg'
import bucky from '../images/bucky.jpeg'

import '../css/typography.css';

const Specialists = () => {
    return (
        <body className="leading-normal tracking-normal text-white gradient">
            <Navigation />
            <div className="pt-4">
                <Waves />
            </div>

            <section className="bg-gray-100 py-8">
                <div className="container max-w-5xl mx-auto px-2 py-4 text-gray-800">
                    <h1 className="w-full my-2 text-3xl font-bold leading-tight text-center text-gray-800">Your Specialists</h1>
                    <div className="w-full mb-4">
                        <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
                    </div>

                    <div className="flex flex-col md:flex-row justify-center items-center sm:my-4">
                        <div className="md:w-1/2 p-6">
                            <img className="imageFilter rounded-lg mx-auto max-h-96" src={dario2} alt="Dario Mexia" />
                        </div>
                        <div className="w-full md:w-1/2 p-6">
                            <p className="text-2xl font-bold leading-tight text-center text-gray-800">
                                Dario
                            </p>
                            <br />
                            <p>
                                Dario Mexia is not your average massage therapist. His last name, "Mexia," comes from an old Spanish variant meaning "medicine" or "healer" , a fitting legacy that fuels his passion for helping others move, feel, and perform at their best.
                            </p>
                            <br />
                            <p>
                                Originally from Colombia, Dario earned a Bachelor's degree in Economics before moving to the U.S. in 2012. However, his true calling led him to the world of manual therapy and bodywork. After completing a massage therapy program and becoming a certified personal trainer, he has continued to refine his craft through advanced training in Structural Integration, Myofascial Release, Fascia Stretch Therapy , Cupping Therapy (a.k.a Myofascial Decompression), Scraping Therapy, Sports Massage and Medical Massage.
                            </p>
                            <br />
                            <p>
                                As a former semi-professional volleyball player, Dario understands the demands placed on the body whether you're an athlete, an active professional, or someone dealing with chronic tension. His approach goes beyond relaxation; he specializes in restoring mobility, relieving pain, and optimizing performance through customized, hands-on techniques.
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row justify-center items-center sm:my-4">
                        <div className="md:w-1/2 p-6">
                            <img className="imageFilter rounded-lg mx-auto max-h-96" src={ryan} alt="Ryan Holbert" />
                        </div>
                        <div className="w-full md:w-1/2 p-6">
                            <p className="text-2xl font-bold leading-tight text-center text-gray-800">
                                Ryan
                            </p>
                            <br />
                            <p>
                                Ryan Holbert is a licensed massage therapist, bodyworker, and certified Accufit Therapist with a deep passion for helping others feel better in their bodies because he knows firsthand what it means to rebuild from the ground up.
                            </p>
                            <br />
                            <p>
                                With over a decade of experience in massage and bodywork, Ryan draws from a diverse background that blends clinical knowledge with intuitive touch. His approach is deeply informed by both science and personal transformation. Years ago, Ryan faced a life-altering diagnosis: a brain tumor that left him relearning how to walk, move, and reconnect with his own body. That journey, filled with physical therapy, resilience, and self-discovery, reshaped not only his life but also his philosophy as a healer.
                            </p>
                            <br />
                            <p>
                                Ryan specializes in therapeutic massage, neuromuscular techniques, and advanced bodywork for pain relief, injury recovery, and performance optimization. He's particularly skilled at working with athletes, chronic pain clients, and those navigating post-surgical or neurological recovery. His training in Accufit therapy allows him to offer a cutting-edge, non-invasive approach to muscle activation and strengthening.
                            </p>
                            <br />
                            <p>
                                Clients often say Ryan brings a rare combination of strength, sensitivity, and presence to the table - someone who truly listens to the body and meets it where it is. Whether you're in need of deep restorative work or focused therapeutic care, Ryan's work is rooted in empathy, precision, and purpose.
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row justify-center items-center sm:my-4">
                        <div className="md:w-1/2 p-6">
                            <img className="imageFilter rounded-lg mx-auto max-h-96" src={bucky} alt="Bucky" />
                        </div>
                        <div className="w-full md:w-1/2 p-6">
                            <p className="text-2xl font-bold leading-tight text-center text-gray-800">
                                Bucky
                            </p>
                            <br />
                            <p>
                                With over a decade of experience in the health and wellness space, Bucky brings a holistic, integrated approach shaped by his work as a personal trainer, yoga teacher, and somatic healing guide. Drawing from a range of tools—including breathwork, vinyasa-style yoga, and therapeutic bodywork—his sessions support overall wellness by tending to the body, mind, and nervous system as a whole.
                            </p>
                            <br />
                            <p>
                                Known for his soft, grounded presence, Bucky creates a space where clients feel safe to unwind, release tension, and restore balance in their own natural rhythm. Through a blend of mindful movement, conscious breathing, and intuitive touch, he encourages deeper awareness and connection within the body.
                            </p>
                            <br />
                            <p>
                                Rather than forcing change, his work emphasizes allowing—meeting each person exactly where they are. Whether through gentle flow, guided breathwork, or targeted massage, each session is thoughtfully tailored to support ease, resilience, and lasting well-being.
                            </p>
                            <br />
                            <p>
                                Outside of his work, Bucky is an avid reader, home cook, and world traveler, drawing inspiration from these passions to enrich both his life and the experiences he offers.
                            </p>

                        </div>
                    </div>
                </div>
            </section>

            <Cta />
            <Footer />
        </body>
    )
}

export default Specialists;
